// extracted by mini-css-extract-plugin
module.exports = {"root":"Sider_root__3rNRH","mobileDrawer":"Sider_mobileDrawer__1B8fC","icon":"Sider_icon__2znyV","siderHeader":"Sider_siderHeader__30vZQ","title":"Sider_title__2Y8n7"};